module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Teleport', {
    attrs: {
      "to": "body"
    }
  }, [_c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "remove_participant_modal",
      "role": "dialog",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-sm"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("DELETE " + _vm._s(_vm.participantSingularName.toUpperCase()))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('p', [_vm._v("Enter your password to confirm the deletion of this " + _vm._s(_vm.participantSingularName.toLowerCase()) + ".")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("NOTE: Clicking OK will permanently delete the " + _vm._s(_vm.participantSingularName.toLowerCase()) + ".")]), _vm._v(" "), _c('form', {
    attrs: {
      "autocomplete": "off"
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.userPassword),
      expression: "userPassword"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "remove-participant-password",
      "type": "password"
    },
    domProps: {
      "value": (_vm.userPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.userPassword = $event.target.value
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn green mt-ladda-btn ladda-button remove-participant-control",
    attrs: {
      "data-dismiss": "modal",
      "data-style": "expand-left"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.doRemoveParticipant()
      }
    }
  }, [_c('span', {
    staticClass: "ladda-label"
  }, [_vm._v("OK")])]), _vm._v(" "), _c('button', {
    staticClass: "btn default",
    attrs: {
      "data-dismiss": "modal"
    }
  }, [_vm._v("Cancel")])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1ff4bb30","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/RemoveParticipantModal.vue
// module id = 1580
// module chunks = 1